import type { ReactNode } from 'react';
import { ExternalLink } from '@/components/external-link';
import { findUrls } from '@/lib/detect-urls';
import styles from './linkify-urls.module.css';

// Splits plain text on URLs (schemed, www.-prefixed, or bare-domain-with-TLD)
// and wraps each in an ExternalLink (safe-anchor markup + the cross-origin
// click interstitial). The visible label is the text the user typed; the href
// is always an http(s) URL (scheme-less matches normalized to https by
// findUrls) so ExternalLink's `new URL(href, location)` can never resolve a
// bare token against our own origin. Built from React elements only — no
// dangerouslySetInnerHTML, no XSS surface. Shared by the post/comment body
// renderer and the chat message bubble.
export function linkifyUrls(text: string, keyPrefix: string): ReactNode {
  const matches = findUrls(text);
  if (matches.length === 0) return text;
  const segments: ReactNode[] = [];
  let last = 0;
  for (const m of matches) {
    if (m.index > last) segments.push(text.slice(last, m.index));
    segments.push(
      <ExternalLink key={`${keyPrefix}u${m.index}`} href={m.href} className={styles.link}>
        {m.raw}
      </ExternalLink>,
    );
    last = m.index + m.raw.length;
  }
  if (last < text.length) segments.push(text.slice(last));
  return segments.length === 1 ? segments[0] : segments;
}
